import React from 'react';
import Select from 'react-select';

const OpenWidgetHeader = ({
  options = [],
  selectedValue,
  onChangeValue,
  SelectStyles,
  SingleValueComponent,
  leftSelectWidth = '185px',
  rightIcons = [],
  formatOptionLabel,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        margin: '12px 12px 0px 12px',
        paddingBottom: '5px',
        borderBottom: '1px solid #F5F5F5',
      }}
    >
      {/* Select on Left */}
      <div>
        <Select
          options={options}
          value={options.find((o) => o.value === selectedValue)}
          onChange={(opt) => onChangeValue(opt.value)}
          styles={{
            ...SelectStyles,
            control: (base, state) => ({
              ...SelectStyles.control(base, state),
              width: leftSelectWidth,
            }),
          }}
          components={SingleValueComponent ? { SingleValue: SingleValueComponent } : undefined}
          isSearchable={false}
          formatOptionLabel={formatOptionLabel}
        />
      </div>

      {/* Icons on Right */}
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
        {rightIcons.map(({ onClick, Icon, style = {}, key }) => (
          <div
            key={key}
            onClick={onClick}
            style={{
              display: 'flex',
              cursor: 'pointer',
              marginLeft: '10px',
              ...style,
            }}
          >
            <Icon />
          </div>
        ))}
      </div>
    </div>
  );
};

export default OpenWidgetHeader;
